import { AxiosResponse, AxiosInstance } from 'axios';

type Data = AxiosResponse<any>;

const API =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

export { Data, AxiosInstance, API };



// WEBPACK FOOTER //
// ./src/services/dadata/types.ts